// extracted by mini-css-extract-plugin
module.exports = {"o1c85q28":"o1c85q28","wm9vynf":"wm9vynf","r1lxvgy6":"r1lxvgy6"};